import { Button, Divider, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Link from 'next/link'
import React from 'react'
import { format } from 'date-fns'

import { Post as IPost } from '../../../types/post'
import { urls } from '../../utils/config'
import { truncate } from '../../utils/string'

const useStyles = makeStyles((theme) => ({
  container: {
    margin: '20px auto',
    maxWidth: '275px',
  },
  subcontainer: {
    margin: '40px auto',
    display: 'flex',
    zIndex: 100,
    flexDirection: 'column',
    maxWidth: '678px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      margin: 0,
    },
    '&:hover': {
      cursor: 'pointer',
      opacity: 0.8,
    },
  },
  title: {
    fontFamily: 'Space Grotesk',
    fontWeight: 'bold',
    fontSize: '24px',
    letterSpacing: 0,
    [theme.breakpoints.down('md')]: {
      marginTop: '20px',
      textAlign: 'left',
    },
  },
  date: {
    fontFamily: 'Inter',
    fontWeight: 'normal',
    fontSize: '14px',
    color: '#787878',
  },
}))

interface Props {
  post: IPost
}

function LatestPost({ post }: Props): JSX.Element {
  const classes = useStyles({})

  return (
    <div className={classes.container}>
      <Link href={`${urls[post.type]}/${post.slug}`}>
        <div className={classes.subcontainer}>
          <Typography className={classes.date}>
            {format(new Date(post.createdAt), 'MMMM yyyy')}
          </Typography>
          <Typography variant="h3" className={classes.title}>
            {truncate(post.title, 40)}
          </Typography>
        </div>
      </Link>
    </div>
  )
}

export default LatestPost
